import OrderSellerRemarksFlag from "@/enum/OrderSellerRemarksFlag";

const SellerFlagNameMap = {
    [OrderSellerRemarksFlag.NONE]: "无旗帜",

    [OrderSellerRemarksFlag.RED]: "红色",

    [OrderSellerRemarksFlag.YELLOW]: "黄色",

    [OrderSellerRemarksFlag.GREEN]: "绿色",

    [OrderSellerRemarksFlag.BLUE]: "蓝色",

    [OrderSellerRemarksFlag.PURPLE]: "紫色",

    [OrderSellerRemarksFlag.ORANGE]: "橙色",

    [OrderSellerRemarksFlag.LIGHT_BLUE]: "浅蓝色",

    [OrderSellerRemarksFlag.PINK]: "粉色",

    [OrderSellerRemarksFlag.DARK_GREEN]: "深绿色",

    [OrderSellerRemarksFlag.PEACH]: "桃红色",
};

export default SellerFlagNameMap;
